import { splitHighlight } from "@/shared/lib/splitHighlight";

export interface CtaHeadingProps {
  /** El título completo, ya traducido. */
  children: string;
  /**
   * La parte del título que va resaltada. Debe aparecer literalmente
   * dentro de `children`; si no aparece, el título se pinta entero sin
   * resaltar en vez de romperse.
   */
  highlight?: string;
}

/**
 * El título del bloque de CTA, con una palabra resaltada.
 *
 * ── Por qué recibe el título entero y no tres trozos ─────────────────
 * La tentación era `<CtaHeading before="¿Listo para transformar tu"
 * highlight="bienestar" after="?">`. Eso obliga a partir la frase en el
 * archivo de traducción, y una frase partida no se puede traducir: en
 * inglés la palabra resaltada cae en otra posición. Aquí llega la frase
 * completa —una sola clave de traducción, traducible— y el componente
 * busca dentro qué resaltar.
 *
 * La búsqueda no se hace aquí: la hace `splitHighlight`, en `shared/lib`.
 * El titular de las portadas de página (`PageHeroTitle`) tiene el mismo
 * problema y ninguna otra cosa en común con este —uno es un `<h2>` blanco
 * sobre tinta y el otro un `<h1>` oscuro sobre crema—, así que lo que se
 * comparte es la REGLA, no el estilo.
 */
export function CtaHeading({ children, highlight }: CtaHeadingProps) {
  const { before, highlight: hit, after } = splitHighlight(children, highlight);

  return (
    <h2 className="mt-4 text-[28px] font-light leading-[1.15] tracking-tight text-white sm:text-ds-h2">
      {before}
      {hit && <em className="font-semibold not-italic text-ds-lilac">{hit}</em>}
      {after}
    </h2>
  );
}
